// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Overlay_loadingOverlay__LOh7G","spinner":"Overlay_spinner__6icik","rotate":"Overlay_rotate__LM6Gq"};